import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useSearchParams } from 'react-router-dom';
import {
  Box,
  Container,
  Avatar,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  TableFooter,
  TablePagination,
  TextField,
  Divider
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import UserListSkelet from '../../skeletons/UserListSkelet';
import { useDelete, useGet } from '../../API/request';
import { useConfirm } from '../../components/Confirm/index';
import { BallTriangle } from 'react-loader-spinner';
import '../../styles/All.css';
import useSavePagePagination from '../../hooks/useSavePagePagination';

const BannersList = () => {
  const confirm = useConfirm();
  const getU = useGet();
  const deleteU = useDelete();
  const {page, limit, setPage, setLimit}  = useSavePagePagination('banners-paginatation')
  const [isLoaded, setIsLoaded] = useState(true);
  const [isDataLoading, setIsDataLoading] = useState(true);
  const [banners, setBanners] = useState([]);
  const [count, setCount] = useState(0);

  const loadBanners = () => {
    setIsDataLoading(true);
    setIsLoaded(true);

    let endpoint = `banners?page=${page + 1}&limit=${limit}`;

    getU(endpoint)
      .then((resp) => {
        if (resp.status === 'success') {
          setBanners(resp.data.banner);
          setCount(resp.data.totalCount || 0);
        }
        setIsDataLoading(false);
      })
      .catch((err) => {
        console.log(err.response);
        setBanners([]);
        setCount(0);
        setIsDataLoading(false);
      })
      .finally(() => {
        setIsLoaded(false);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeLimit = (event) => {
    setLimit(event.target.value);
    setPage(0);
  };

  const onDelete = (id) => {
    confirm({
      title: 'Удаление',
      content: 'Вы уверены, что хотите удалить услугу?',
      onConfirm: () => {
        deleteU(`banners/${id}`)
          .then((resp) => {
            if (resp.status === 'success') {
              loadBanners();
            }
          })
          .catch((e) => {
            console.log(e);
          });
      }
    });
  };

  useEffect(() => {
    loadBanners();
  }, [page, limit]);

  if (isLoaded) {
    return (
      <div className="loader">
        <BallTriangle
          height="100"
          width="100"
          color="grey"
          ariaLabel="loading"
        />
      </div>
    );
  }

  const getCityName = (sitys, urlCityId) => {
    if (sitys.length === 0 || !urlCityId) return '';
    const city = sitys.find((el) => el.id === urlCityId);
    return city?.name || '';
  };

  return (
    <>
      <Helmet>
        <title>Баннера</title>
      </Helmet>
      <Box className="headerWrapper">
        <Box className="headerTitle">Баннера</Box>
      </Box>
      <Box
        sx={{ backgroundColor: 'background.default', minHeight: '100%', py: 3 }}
      >
        <Container maxWidth={false}>
          {isDataLoading ? (
            <UserListSkelet />
          ) : (
            <>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Box sx={{ marginLeft: 2 }}>
                  <Link to="/app/banner/add">
                    <Button color="primary" variant="contained">
                      Добавить баннер
                    </Button>
                  </Link>
                </Box>
              </Box>
              <Box sx={{ pt: 3 }}>
                <Card>
                  <PerfectScrollbar>
                    <Box sx={{ minWidth: 1000 }}>
                      <Divider />
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell sx={{ width: 80 }}>Id</TableCell>
                            <TableCell>Изображение</TableCell>
                            <TableCell>Название баннера</TableCell>
                            <TableCell>Ссылки</TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {banners?.map((banner) => (
                            <TableRow hover key={banner.id}>
                              <TableCell sx={{ width: 80 }}>
                                {banner?.id || '---'}
                              </TableCell>
                              <TableCell>
                                <Box
                                  sx={{ alignItems: 'center', display: 'flex' }}
                                >
                                  <Avatar
                                    src={
                                      banner.mobile_img
                                        ? `${process.env.REACT_APP_API_URL}public/uploads/images/${banner.mobile_img}`
                                        : ''
                                    }
                                  />
                                </Box>
                              </TableCell>
                              <TableCell>{banner?.title || '---'}</TableCell>
                              {banner.urls.length > 0 ? (
                                <TableCell>
                                  <ul>
                                    {banner.urls
                                      .filter((item) => getCityName(banner.city, item.city_id))
                                      .map((item) => (
                                      <div
                                        key={item.id}
                                        style={{
                                          paddingTop: 5,
                                          display: 'flex'
                                        }}
                                      >
                                        <div
                                          style={{
                                            width: '120px',
                                            display: 'flex'
                                          }}
                                        >
                                          {`${getCityName(
                                            banner.city,
                                            item.city_id
                                          )}:`}
                                        </div>
                                        <div>{item?.url || '---'}</div>
                                      </div>
                                    ))}
                                  </ul>
                                </TableCell>
                              ) : (
                                <TableCell>{'---'}</TableCell>
                              )}
                              <TableCell>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    justifyContent: 'flex-end'
                                  }}
                                >
                                  <Link to={`/app/banner/${banner.id}`}>
                                    <Button color="primary" variant="contained">
                                      Инфо.
                                    </Button>
                                  </Link>
                                  <Box sx={{ ml: 2 }}>
                                    <Link to={`/app/banner/edit/${banner.id}`}>
                                      <Button
                                        color="primary"
                                        variant="contained"
                                      >
                                        Редакт.
                                      </Button>
                                    </Link>
                                  </Box>
                                  <Box sx={{ ml: 2 }}>
                                    <Button
                                      color="error"
                                      variant="contained"
                                      onClick={(e) => e && onDelete(banner.id)}
                                    >
                                      Удалить
                                    </Button>
                                  </Box>
                                </Box>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              labelRowsPerPage={
                                <span>Кол-во строк на странице:</span>
                              }
                              rowsPerPageOptions={[10, 20, 30, 40, 50]}
                              colSpan={6}
                              count={count}
                              rowsPerPage={limit}
                              page={page}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeLimit}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </Box>
                  </PerfectScrollbar>
                </Card>
              </Box>
            </>
          )}
        </Container>
      </Box>
    </>
  );
};

export default BannersList;
